import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Crud} from '../services/crud';
import {Injectable, OnInit} from '@angular/core';
import * as moment from 'moment';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class CrudEdit implements OnInit {

  entitylabelkey = '';
  entityformconfig: {};

  entityForm: UntypedFormGroup;
  submittedEntityForm: boolean;
  entity: any = {};
  completeEntity: any = {};
  entityid = '';

  redirecturl = '';

  constructor(
    protected httpcrud: Crud,
    protected fb: UntypedFormBuilder,
    protected route: ActivatedRoute,
    protected router: Router,
  ) {
  }

  ngOnInit(): void {
    this.initSpecificEditConfig();
    this.initEditForm();
  }


  get f() {
    return this.entityForm.controls;
  }

  initSpecificEditConfig() {

  } // initSpecificConfig

  initEditForm() {
    this.submittedEntityForm = false;

    const emptyConfig = {};
    for (const config of this.getFormConfigs()) {
      emptyConfig[config.field] = '';
    } // for

    this.entityid = this.route.snapshot.paramMap.get('id');
    this.entityForm = this.fb.group(emptyConfig);
    this.linkFormWithValidators();

    if (this.entityid) {
      // Edit
      const query = this.httpcrud.getEntity(this.entityid);
      query.subscribe((allresults) => {
        this.completeEntity = allresults.results;
        // Use only values from entity form config
        this.entity = this.filterEntity(this.completeEntity, this.getFormConfigs());

        this.entityForm = this.fb.group(this.entity);
        this.linkFormWithValidators();

      });
    } else {
      // Create
    } // if
  }


  getFormConfigs(): any {
    return Object.values(this.entityformconfig);
  } // getFormConfigs

  filterEntity(entity: {}, configs = []) {
    const newentity = {};
    // for (const el of entity) {
    //   console.log(el);
    // }
    for (const configitem of configs) {
      const key = configitem.field;
      newentity[key] = entity[key];
    } // for

    return newentity;
  } // filterEntity

  linkFormWithValidators() {
    for (const config of this.getFormConfigs()) {
      if (config.required) {
        const field = this.entityForm.get(config.field) as UntypedFormControl;
        field.setValidators([Validators.required]);
      }
    } // for
  }

  isFieldWithError(fieldname) {
    return this.submittedEntityForm && this.f[fieldname].errors;
  }

  onEntityFormSubmit() {
    this.submittedEntityForm = true;

    if (this.entityForm.valid) {
      const entityjson = this.entityForm.getRawValue();

      if ('password' in entityjson && 'password_repeat' in entityjson) {
        // form has pwd, pwd confirmation and username
        if (entityjson.password === entityjson.password_repeat) {
          console.log('password = password_repeat');

          if (this.entityid) {
            const username = entityjson.username;
            const password = CryptoJS.MD5(entityjson.password).toString();

            const credential = username + '|-|||-|' + password;
            const encryptedWord = CryptoJS.enc.Utf8.parse(credential); // encryptedWord Array object
            const encryptedCredential = CryptoJS.enc.Base64.stringify(encryptedWord);

            delete entityjson.username;
            delete entityjson.password;
            delete entityjson.password_repeat;

            const ItemToSend = [entityjson, encryptedCredential];
            console.log('entityid: ' + this.entityid);
            console.log('json:');
            console.log(ItemToSend);
            const query = this.httpcrud.updateEntity(this.entityid, ItemToSend);
            query.subscribe((allresults) => {
              this.router.navigate([this.redirecturl]);
            });
          }
        } else {
          // Form validation failed
          console.log('pwd is not valid');
          // if (this.entityForm.controls['password'].errors && this.entityForm.controls['password_repeat'].errors ) {
          //   console.log('both are filled');
          //   // this.loginError = 'Please enter your login.';
          // } else if (this.entityForm.controls['password'].errors && !this.entityForm.controls['password_repeat'].errors || !this.entityForm.controls['password'].errors && this.entityForm.controls['password_repeat'].errors) {
          //   console.log('one field is filled');
          //   // this.loginError = 'Please enter your password.';
          // } // else if, if
        }
      } else {
        if (entityjson.eventDatekey) {
          entityjson.eventDatekey = moment(entityjson.eventDatekey).format('YYYY-MM-DD HH:MM:SS');
        }
        if (entityjson.validTokey) {
          entityjson.validTokey = moment(entityjson.validTokey).format('YYYY-MM-DD HH:MM:SS');
        }
        if (entityjson.validFromkey) {
          entityjson.validFromkey = moment(entityjson.validFromkey).format('YYYY-MM-DD HH:MM:SS');
        }

        if (this.entityid) {
          const query = this.httpcrud.updateEntity(this.entityid, entityjson);
          query.subscribe((allresults) => {
            this.router.navigate([this.redirecturl]);
          });
        } else {
          const query = this.httpcrud.createEntity(entityjson);
          query.subscribe((allresults) => {
            this.router.navigate([this.redirecturl]);
          });
        } // if
      } // if
    } else {
      console.log(this.entityForm);
    }
  }

  cancelFormSubmit() {
    this.router.navigate([this.redirecturl]);
  }

  cancelSubFormSubmit() {
    this.router.navigate([this.redirecturl]);
  }


}
